// import { isArray } from '@lhb/func';
// import { asicsBrandGather } from '../pages/costume-asics/ts-config';
export default {
    state: {
        chancepointForm: null,
        chancepointGrade: null,
        scoreDetail: null,
    },
    actions: {},
    mutations: {
        CHANCEPOINT_FORM: function (state, val) {
            state.chancepointForm = val;
        },
        CHANCEPOINT_GRADE: function (state, val) {
            state.chancepointGrade = val;
        },
        SCORE_DETAIL: function (state, val) {
            state.scoreDetail = val;
        },
    },
    getters: {}
};
